document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('gf-calc');
  if (!root) return;

  const prices = {
    arch: 2500,
    aisle: 250,
    sign: 350,
    petals: 300,
    centerpiece: { petite: 195, classic: 295, statement: 425 },
    runnerPerFoot: 120,
    sweetheart: 650,
    cake: 150,
    bouquet: { none: 0, signature: 250, luxury: 350 },
    bridesmaids: 150,
    boutonniere: 35,
    corsage: 25
  };

  const state = {
    arch: false,
    aisle: false,
    aisleQty: 4,
    sign: false,
    petals: false,
    centerpieceTier: 'petite',
    tables: 0,
    runner: 0,
    sweetheart: false,
    cake: false,
    bouquet: 'none',
    bridesmaids: 0,
    boutonniere: 0,
    corsage: 0
  };

  const els = {
    total: root.querySelector('#gf-liveTotal'),
    mood: root.querySelector('#gf-moodText'),
    summary: root.querySelector('#gf-summary'),
    summaryTotal: root.querySelector('#gf-summaryTotal'),
    summaryItems: root.querySelector('#gf-summaryItems'),
    summaryToggle: root.querySelector('#gf-summaryToggle'),
    tableSub: root.querySelector('#gf-table-sub'),
    vAisle: root.querySelector('#gf-v-aisle'),
    sAisle: root.querySelector('#gf-s-aisle'),
    vTables: root.querySelector('#gf-v-tables'),
    vRunner: root.querySelector('#gf-v-runner'),
    sRunner: root.querySelector('#gf-s-runner'),
    vBridesmaids: root.querySelector('#gf-v-bridesmaids'),
    vBoutonniere: root.querySelector('#gf-v-boutonniere'),
    vCorsage: root.querySelector('#gf-v-corsage'),
    copyBtn: root.querySelector('#gf-copyBtn')
  };

  function money(n) {
    return '$' + Number(n).toLocaleString('en-US');
  }

  function clampNonNegative(n, fallback) {
    const x = parseInt(n, 10);
    if (Number.isNaN(x)) return fallback;
    return Math.max(0, x);
  }

  function setDrawer(drawer, open) {
    if (!drawer) return;
    if (open) {
      drawer.classList.add('open');
      drawer.style.height = drawer.scrollHeight + 'px';
    } else {
      drawer.classList.remove('open');
      drawer.style.height = '0px';
    }
  }

  function updateCardVisual(key) {
    const card = root.querySelector('[data-toggle="' + key + '"]');
    if (!card) return;

    const isOn = !!state[key];
    card.classList.toggle('on', isOn);

    if (key === 'aisle') {
      setDrawer(root.querySelector('#gf-q-aisle'), isOn);
    }
  }

  function updateTierVisuals() {
    root.querySelectorAll('[data-tier]').forEach(function (btn) {
      const active = btn.getAttribute('data-tier') === state.centerpieceTier;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-bouquet]').forEach(function (btn) {
      const active = btn.getAttribute('data-bouquet') === state.bouquet;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (els.tableSub) {
      const tierLabel =
        state.centerpieceTier.charAt(0).toUpperCase() +
        state.centerpieceTier.slice(1);

      els.tableSub.textContent =
        tierLabel + ' centerpiece at ' +
        money(prices.centerpiece[state.centerpieceTier]) + ' each';
    }
  }

  function sanitizeState() {
    state.aisleQty = Math.max(1, clampNonNegative(state.aisleQty, 4));
    state.tables = clampNonNegative(state.tables, 0);
    state.runner = clampNonNegative(state.runner, 0);
    state.bridesmaids = clampNonNegative(state.bridesmaids, 0);
    state.boutonniere = clampNonNegative(state.boutonniere, 0);
    state.corsage = clampNonNegative(state.corsage, 0);

    if (!prices.centerpiece[state.centerpieceTier]) {
      state.centerpieceTier = 'petite';
    }

    if (typeof prices.bouquet[state.bouquet] === 'undefined') {
      state.bouquet = 'none';
    }
  }

  function buildLines() {
    sanitizeState();
    const lines = [];

    if (state.arch) {
      lines.push(['Arch Floral Installation', prices.arch]);
    }

    if (state.aisle) {
      lines.push([
        'Aisle Arrangements × ' + state.aisleQty,
        prices.aisle * state.aisleQty
      ]);
    }

    if (state.sign) {
      lines.push(['Welcome Sign Accent Florals', prices.sign]);
    }

    if (state.petals) {
      lines.push(['Aisle Petal Scatter', prices.petals]);
    }

    if (state.tables > 0) {
      const tierLabel =
        state.centerpieceTier.charAt(0).toUpperCase() +
        state.centerpieceTier.slice(1);

      lines.push([
        tierLabel + ' Centerpieces × ' + state.tables,
        prices.centerpiece[state.centerpieceTier] * state.tables
      ]);
    }

    if (state.runner > 0) {
      lines.push([
        'Head Table Floral Runner × ' + state.runner + ' ft',
        prices.runnerPerFoot * state.runner
      ]);
    }

    if (state.sweetheart) {
      lines.push(['Sweetheart Table Design', prices.sweetheart]);
    }

    if (state.cake) {
      lines.push(['Cake Floral Accent', prices.cake]);
    }

    if (state.bouquet !== 'none') {
      const bouquetName = state.bouquet === 'signature'
        ? 'Signature Bridal Bouquet'
        : 'Luxury Garden Bridal Bouquet';

      lines.push([bouquetName, prices.bouquet[state.bouquet]]);
    }

    if (state.bridesmaids > 0) {
      lines.push([
        'Bridesmaid Bouquets × ' + state.bridesmaids,
        prices.bridesmaids * state.bridesmaids
      ]);
    }

    if (state.boutonniere > 0) {
      lines.push([
        'Boutonnieres × ' + state.boutonniere,
        prices.boutonniere * state.boutonniere
      ]);
    }

    if (state.corsage > 0) {
      lines.push([
        'Corsages × ' + state.corsage,
        prices.corsage * state.corsage
      ]);
    }

    return lines;
  }

  function totalCost() {
    return buildLines().reduce(function (sum, line) {
      return sum + line[1];
    }, 0);
  }

  function moodText(total) {
    if (total === 0) return 'Select your elements below.';
    if (total < 3000) return 'A lovely starting point with room to build.';
    if (total < 7000) return 'Elegant and well-balanced floral coverage.';
    if (total < 12000) return 'A lush wedding floral story is taking shape.';
    return 'This is entering full romantic spectacle territory.';
  }

  function renderSummary(lines, total) {
    if (!els.summary || !els.summaryItems || !els.summaryTotal) return;

    if (lines.length === 0) {
      els.summary.classList.remove('show');
      els.summaryTotal.textContent = '$0';
      els.summaryItems.innerHTML =
        '<div class="summary-line">' +
          '<div class="summary-line-name">No selections yet</div>' +
          '<div class="summary-line-price">$0</div>' +
        '</div>';
      return;
    }

    els.summary.classList.add('show');
    els.summaryTotal.textContent = money(total);

    els.summaryItems.innerHTML = lines.map(function (line) {
      return '<div class="summary-line">' +
        '<div class="summary-line-name">' + line[0] + '</div>' +
        '<div class="summary-line-price">' + money(line[1]) + '</div>' +
        '</div>';
    }).join('');
  }

  function render() {
    sanitizeState();

    updateCardVisual('arch');
    updateCardVisual('aisle');
    updateCardVisual('sign');
    updateCardVisual('petals');
    updateCardVisual('sweetheart');
    updateCardVisual('cake');
    updateTierVisuals();

    if (els.vAisle) els.vAisle.textContent = state.aisleQty;
    if (els.sAisle) {
      els.sAisle.textContent = money(prices.aisle * state.aisleQty);
    }

    if (els.vTables) els.vTables.textContent = state.tables;
    if (els.vRunner) els.vRunner.textContent = state.runner;

    if (els.sRunner) {
      els.sRunner.textContent = state.runner > 0
        ? money(prices.runnerPerFoot * state.runner)
        : '—';
    }

    if (els.vBridesmaids) {
      els.vBridesmaids.textContent = state.bridesmaids;
    }

    if (els.vBoutonniere) {
      els.vBoutonniere.textContent = state.boutonniere;
    }

    if (els.vCorsage) els.vCorsage.textContent = state.corsage;

    const lines = buildLines();
    const total = totalCost();

    if (els.total) els.total.textContent = money(total);
    if (els.mood) els.mood.textContent = moodText(total);

    renderSummary(lines, total);
  }

  root.querySelectorAll('.card[data-toggle] .card-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const card = btn.closest('.card[data-toggle]');
      if (!card) return;

      const key = card.getAttribute('data-toggle');
      state[key] = !state[key];
      render();
    });
  });

  root.querySelectorAll('[data-adj]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.getAttribute('data-adj');
      const delta = parseInt(btn.getAttribute('data-delta'), 10) || 0;

      if (key === 'aisle') {
        state.aisleQty = Math.max(1, state.aisleQty + delta);
        if (!state.aisle) state.aisle = true;
      } else if (key === 'tables') {
        state.tables = Math.max(0, state.tables + delta);
      } else if (key === 'runner') {
        state.runner = Math.max(0, state.runner + delta);
      } else if (key === 'bridesmaids') {
        state.bridesmaids = Math.max(0, state.bridesmaids + delta);
      } else if (key === 'boutonniere') {
        state.boutonniere = Math.max(0, state.boutonniere + delta);
      } else if (key === 'corsage') {
        state.corsage = Math.max(0, state.corsage + delta);
      }

      render();
    });
  });

  root.querySelectorAll('[data-tier]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.centerpieceTier = btn.getAttribute('data-tier');
      render();
    });
  });

  root.querySelectorAll('[data-bouquet]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.bouquet = btn.getAttribute('data-bouquet');
      render();
    });
  });

  root.querySelectorAll('[data-scn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const scn = btn.getAttribute('data-scn');

      if (scn === 'intimate') {
        state.arch = false;
        state.aisle = true;
        state.aisleQty = 4;
        state.sign = true;
        state.petals = false;
        state.centerpieceTier = 'classic';
        state.tables = 10;
        state.runner = 6;
        state.sweetheart = true;
        state.cake = true;
        state.bouquet = 'signature';
        state.bridesmaids = 3;
        state.boutonniere = 4;
        state.corsage = 2;
      } else if (scn === 'classic') {
        state.arch = true;
        state.aisle = true;
        state.aisleQty = 6;
        state.sign = true;
        state.petals = true;
        state.centerpieceTier = 'classic';
        state.tables = 18;
        state.runner = 8;
        state.sweetheart = true;
        state.cake = true;
        state.bouquet = 'luxury';
        state.bridesmaids = 5;
        state.boutonniere = 6;
        state.corsage = 3;
      } else if (scn === 'grand') {
        state.arch = true;
        state.aisle = true;
        state.aisleQty = 8;
        state.sign = true;
        state.petals = true;
        state.centerpieceTier = 'statement';
        state.tables = 25;
        state.runner = 10;
        state.sweetheart = true;
        state.cake = true;
        state.bouquet = 'luxury';
        state.bridesmaids = 7;
        state.boutonniere = 8;
        state.corsage = 4;
      }

      render();
    });
  });

  if (els.summaryToggle && els.summary) {
    els.summaryToggle.addEventListener('click', function () {
      const expanded = els.summary.classList.toggle('expanded');
      els.summaryToggle.setAttribute(
        'aria-expanded',
        expanded ? 'true' : 'false'
      );
    });
  }

  if (els.copyBtn) {
    els.copyBtn.addEventListener('click', function () {
      const lines = buildLines();
      const total = totalCost();

      const text =
        'Golzaria Wedding Floral Estimate\n\n' +
        (lines.length
          ? lines.map(function (line) {
              return '- ' + line[0] + ': ' + money(line[1]);
            }).join('\n')
          : '- No selections yet') +
        '\n\nEstimated Total: ' + money(total);

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          els.copyBtn.textContent = 'Copied';

          setTimeout(function () {
            els.copyBtn.textContent = 'Copy Estimate';
          }, 1400);
        });
      }
    });
  }

  // Update visible prices to match the calculation prices.
  function setText(selector, value) {
    const element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  setText('[data-toggle="arch"] .card-price', money(prices.arch));
  setText('[data-toggle="aisle"] .card-price', money(prices.aisle));
  setText(
    '[data-bouquet="signature"] .tier-opt-price',
    money(prices.bouquet.signature)
  );
  setText(
    '[data-bouquet="luxury"] .tier-opt-price',
    money(prices.bouquet.luxury)
  );

  const bridesmaidControl = root.querySelector('[data-adj="bridesmaids"]');

  if (bridesmaidControl) {
    const row = bridesmaidControl.closest('.count-row');
    if (row) {
      const label = row.querySelector('.count-sub');
      if (label) {
        label.textContent = money(prices.bridesmaids) + ' per bridesmaid';
      }
    }
  }

  // Calculate the sample scenario labels, then restore empty selections.
  const savedState = Object.assign({}, state);

  root.querySelectorAll('[data-scn]').forEach(function (button) {
    button.click();
    const label = button.querySelector('.scenario-price');
    if (label) label.textContent = money(totalCost());
  });

  Object.assign(state, savedState);
  render();
});